import { createApp } from 'vue'
import App from './App.vue'
import router from '../router.js';

// Vuetify
import 'vuetify/styles'
import vuetify from './plugins/vuetify.config'; 


createApp(App).use(router).use(vuetify).mount('#app')
